<template>
  <v-container tag="section">
    <material-wizard
      :title="title"
      subtitle="Preencha as Informações para gerar sua unitização."
      v-model="tab"
      :available-steps="availableSteps"
      :tabs="tabs"
      class="mx-auto"
      @click:next="next(1)"
      @click:prev="tab--"
      :loading="loading"
      btnSaveCustomId="btn-save-unitizacao"
      :disabledBtnFinalizar="validTabs[tab+1] === false"
    >
      <unitizacoes-wizzard-tabs
        ref="unitizacoesParametros"
        :items="unitizacao"
        :dataUltimoIpcaOficial="dataUltimoIpcaOficial"
        :dataUltimoIpcaNaoOficial="dataUltimoIpcaNaoOficial"
        :mesesSemAtualizarIpcaOficial="mesesSemAtualizarIpcaOficial"
        @filtroSelecionado="filtroSelecionado = $event"
        @secondStepAvailable="validTabs[1] = $event"
        @btnFinishAvailable="validTabs[2] = $event"
      />
    </material-wizard>
  </v-container>
</template>

<script>
import UnitizacoesObrasService from '@/services/UnitizacoesObrasService';
import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';
import tourMixins from '@/mixins/tourMixins';
import dayjs from 'dayjs';

export default {
  components: {
    UnitizacoesWizzardTabs: () => import('@/components/unitizacoesObras/UnitizacoesWizzardTabs'),
    MaterialWizard: () => import('@/components/base/MaterialWizard'),
  },

  mixins: [tourMixins],

  mounted() {
    if (this.$route.params.id) {
      this.getUnitizacao(this.$route.params.id);
    }
    this.getUltimoIpca();
    this.iniciarTourPrimeiraTab();
  },

  data: () => ({
    tab: 0,
    tabs: ["Início & Parâmetros", "Filtros"],
    availableSteps: [0],
    validTabs: {0: true, 1: false, 2: undefined},
    loading: false,
    unitizacao: {},
    filtroSelecionado: false,
    dataUltimoIpcaOficial: '',
    dataUltimoIpcaNaoOficial: '',
    mesesSemAtualizarIpcaOficial: 0,
    arrTourPrimeiraTab: [
      {
        element: '#nome-unitizacao',
        intro: 'Aqui você poderá inserir um nome para sua unitização de obras.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#data-aplicacao-modulos-unitizacao',
        intro: 'Aqui você poderá selecionar a data de aplicação dos módulos aneel.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#unitizada-por',
        intro: 'Aqui você poderá selecionar o agrupamento para a unitização de obras (por tucagem ou por matérial).',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#qtd-min-cabo-uar',
        intro: 'Aqui você poderá inserir a quantidade mínima de cabo a ser considerada UAR.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#checkbox-unitizacao-ratear',
        intro: 'Neste campo você poderá escolher ratear o COM e CA específicos para as TUCs.',
        scrollTo: "tooltip",
        position: 'right'
      },
    ],
    arrTourSegundaTab: [
      {
        element: "#obras-unitizacao",
        intro: "Aqui você poderá inserir códigos das obras a serem unitizadas.",
        scrollTo: "tooltip",
        position: "left"
      },
      {
        element: "#nao-pertence-obras-unitizacao",
        intro: "Caso for inserido códigos de obras você poderá optar por utilizar o filtro não pertence",
        scrollTo: "tooltip",
        position: "left"
      },
      {
        element: "#tipologias-unitizacao",
        intro: "Aqui você poderá inserir códigos das tipologias a serem unitizadas.",
        scrollTo: "tooltip",
        position: "top"
      },
      {
        element: "#nao-pertence-tipologias-unitizacao",
        intro: "Caso for inserido tipologias de obras você poderá optar por utilizar o filtro não pertence",
        scrollTo: "tooltip",
        position: "left"
      },
      {
        element: '#data-imobilizacao-unitizacao',
        intro: 'Aqui você poderá inserir um filtro, por data de imobilização, das obras a serem unitizadas.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#btn-save-unitizacao',
        intro: 'Após seleção dos critérios anteriores clique aqui para salvar e executar a unitização de obras.',
        scrollTo: "tooltip",
        position: 'left'
      }
    ]
  }),

  methods: {
    next(valid) {
      if (!valid) return;

      if (this.tab === this.tabs.length - 1) {
        this.salvarUnitizacao()
      } else {
        this.tab++;
      }
    },

    getUnitizacao(id) {
      UnitizacoesObrasService.getUnitizacao(id).then(response => {
        this.availableSteps = [0, 1, 2];
        this.validTabs = {0: true, 1: true, 2: true };
        this.unitizacao = response.data.unitizacao;
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao recuperar unitização.', '',{position:'topRight'});
        this.$router.push({ name: 'Unitizacoes Historico' });
      });
    },

    salvarUnitizacao() {
      const data = this.$refs.unitizacoesParametros.exportData();

      if (!this.filtroSelecionado) {
        this.$toast.warning('Informe ao menos 1 filtro.', '',{position:'topRight'})
        return;
      }
      
      const id = !this.$route.params.id ? null : this.$route.params.id;
      this.loading = true;

      UnitizacoesObrasService.salvarUnitizacao(data, id).then(() => {
        this.$toast.success('Unitização salva com sucesso.', '',{position:'topRight'})
        this.$router.push({ name: 'Unitizações Histórico' });
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao salvar unitização.', '',{position:'topRight'});
      })
      .finally(() => this.loading = false);
    },

    getUltimoIpca() {
      AtualizacaoIndicesService.getUltimoIndiceIpca().then((indice) => {
        this.dataUltimoIpcaOficial = indice.indice_oficial ? indice.indice_oficial.DataRegistro : '';
        this.dataUltimoIpcaNaoOficial = indice.indice_estimado ? indice.indice_estimado.DataRegistro : '';

        let dataAtual = dayjs();
        let qtdMeses = dataAtual.diff((dayjs(this.dataUltimoIpcaOficial)), 'month');
        this.mesesSemAtualizarIpcaOficial = qtdMeses;
      })
      .catch(() => this.$toast.error('Erro ao buscar ultimo Índice IPCA.', '', { position: 'topRight' }));
    },

    iniciarTourPrimeiraTab() {
      this.doneLabel = 'Próximo';
      this.desativarTourAoSair = false;

      let onBeforeExitFunction = {
        func: (() => {
          this.tab = 1;
          this.initTourSegundaTab();
        })
      };
  
      this.iniciarTour(this.arrTourPrimeiraTab, [], [], [onBeforeExitFunction]);
    },

    initTourSegundaTab() {
      this.doneLabel = 'Finalizar';
      this.desativarTourAoSair = true;

      let onBeforeExitFunction = {
        func: (() => this.tab = 0)
      };
      this.iniciarTour(this.arrTourSegundaTab, [], [], [onBeforeExitFunction]);
    }
  },

  computed: {
    title() {
      return this.$route.params.id ? `Editando Unitização` : 'Adicionar Nova Unitização';
    },

    stepsProps() {
      return `${this.validTabs[0]}|${this.validTabs[1]}}`;
    },
  },

  watch: {
    stepsProps() {
      for (let i = 1; i <= 2; i++) {
        (this.validTabs[i] && this.validTabs[i-1]) 
          ? this.availableSteps.push(i) 
          : this.availableSteps = this.availableSteps.filter(key => key != i);
      }
      if (this.validTabs[1] && this.validTabs[2] == undefined) this.availableSteps.push(2);
    }
  }

}
</script>

<style scoped>
  .divisor-picker {
    margin-bottom: 8px;
  }
</style>